import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["isList"],
  _excluded2 = ["data", "state", "dataLayer"],
  _excluded3 = ["isCarousel"],
  _excluded4 = ["isCarousel"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';
import { Pixall, Google } from '../analytics';
import { getInventoryOwnerById, getListingCategory } from '../utilities';
import { DataLayerTransformer } from '../transformers/pixall';
import { ownerWebsiteClickHelper, sanitizeValue } from './helpers';
import { inventoryTransformer as googleInventoryTransformer, productConfigTransformer, pageNameTransformer } from '../transformers/google';
var transformProductConfig = productConfigTransformer.transformProductConfig,
  hasPrice = productConfigTransformer.hasPrice;

/**
 * @summary Sends Pixall impression for selected owner (DDP)
 * @data activeDuck, ownerDuck
 */
export function ownerImpression(_ref, option) {
  var _ref$dataLayer = _ref.dataLayer,
    dataLayer = _ref$dataLayer === void 0 ? {} : _ref$dataLayer,
    state = _ref.state,
    activeDuck = _ref.activeDuck,
    ownersDuck = _ref.ownersDuck,
    history = _ref.history;
  if (activeDuck && ownersDuck) {
    var page = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    var activeOwnerId = activeDuck.selectors.getDuckState(state);
    var owner = ownersDuck.selectors.getOwners(state)[activeOwnerId];
    Pixall.sendImpression({
      dataLayer: dataLayer,
      history: history
    }, {
      label: page,
      listingCode: activeOwnerId,
      eventSource: 'vehicle',
      zip: _get(owner, 'location.address.zip', '')
    }, option);
  } else {
    throw new Error('activeDuck and/or ownersDuck is missing');
  }
  return {};
}

/**
 * @summary Sends Pixall impression for owners
 * @data ownersDuck or ownerIds, resultsDuck, userDuck
 */
export function ownerImpressions(_ref2, option) {
  var _dataLayer$user;
  var _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$dataLayer = _ref2.dataLayer,
    dataLayer = _ref2$dataLayer === void 0 ? {} : _ref2$dataLayer,
    state = _ref2.state,
    resultsDuck = _ref2.resultsDuck,
    history = _ref2.history;
  var response = {};
  var _data$ownerIds = data.ownerIds,
    ownerIds = _data$ownerIds === void 0 ? [] : _data$ownerIds,
    pixallData = data.pixallData;
  var searchZip = ((_dataLayer$user = dataLayer.user) == null ? void 0 : _dataLayer$user.zipCode) || '';
  var activeOwnerIds = resultsDuck ? resultsDuck.selectors.getActiveResults(state) : ownerIds || [];
  var pageName = _get(dataLayer, 'page.pageName', '');
  if (pixallData && (activeOwnerIds == null ? void 0 : activeOwnerIds.length) > 0) {
    var isList = pixallData.isList,
      restPixallData = _objectWithoutPropertiesLoose(pixallData, _excluded);
    Pixall.sendImpression({
      dataLayer: dataLayer,
      history: history
    }, _extends({
      eventSource: isList ? 'vehicle-list' : 'vehicle',
      description: pageName === 'fyd_srl' ? undefined : activeOwnerIds,
      label: pixallData.label ? pixallData.label : '',
      zipCode: searchZip
    }, restPixallData), option);
    response = {
      impressions: activeOwnerIds
    };
  } else {
    throw new Error('resultsDuck/pixallData is missing');
  }
  return response;
}

/**
 * @deprecated
 */
export function ownerClick() {
  return _ownerClick.apply(this, arguments);
}

/**
 * @summary Sends event when owner logo image is clicked
 */
function _ownerClick() {
  _ownerClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {});
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ownerClick.apply(this, arguments);
}
export function ownerLogoClick(_x, _x2) {
  return _ownerLogoClick.apply(this, arguments);
}

/**
 * @summary Sends event when accelerate tile is clicked
 * @data dataLayer
 */
function _ownerLogoClick() {
  _ownerLogoClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, option) {
    var _dataLayer$user2;
    var _ref3$data, data, state, dataLayer, searchZip, par, _data$pixallData5, pixallData, customCmp, _data$ownerId, ownerId, inventoryId, cmp, pageId, inventory, clickType, isCarousel, restPixallData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref3$data = _ref3.data, data = _ref3$data === void 0 ? {} : _ref3$data, state = _ref3.state, dataLayer = _ref3.dataLayer;
          searchZip = ((_dataLayer$user2 = dataLayer.user) == null ? void 0 : _dataLayer$user2.zipCode) || '';
          par = data.par, _data$pixallData5 = data.pixallData, pixallData = _data$pixallData5 === void 0 ? {} : _data$pixallData5, customCmp = data.cmp, _data$ownerId = data.ownerId, ownerId = _data$ownerId === void 0 ? '' : _data$ownerId, inventoryId = data.inventoryId;
          cmp = customCmp || 'c_lgo';
          pageId = DataLayerTransformer.getPageId(dataLayer);
          inventory = getInventoryOwnerById(state, inventoryId);
          clickType = _get(state, 'query.clickType', getListingCategory(par));
          isCarousel = pixallData.isCarousel, restPixallData = _objectWithoutPropertiesLoose(pixallData, _excluded3);
          Pixall.sendClickEvent(_extends({
            label: "Click to Dealer Site - " + cmp + " - " + pageId,
            eventSource: isCarousel ? 'vehicle-carousel' : 'dealership',
            feature: 'Drive the 5',
            listingCode: ownerId,
            searchFacetZipCode: searchZip,
            hasListingType: false,
            zipCode: searchZip,
            inventory: inventory,
            listingType: par
          }, restPixallData), dataLayer, option);
          Google.sendClickEvent({
            eventElement: 'dealer',
            eventResult: "sitelink::" + clickType,
            eventData: {
              vehicle: {
                clickType: clickType,
                dealershipId: ownerId == null ? void 0 : ownerId.toString()
              }
            }
          }, option);

          // return data for custom event
          return _context2.abrupt("return", {
            cmp: cmp,
            par: par
          });
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _ownerLogoClick.apply(this, arguments);
}
export function ownerAccelerateClick(_x3, _x4) {
  return _ownerAccelerateClick.apply(this, arguments);
}

/**
 * @summary Sends event when call dealer button is clicked
 * @data inventoryId, ownerId, userDuck
 */
function _ownerAccelerateClick() {
  _ownerAccelerateClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4, option) {
    var _ref4$data, data, state, dataLayer, par, _data$pixallData6, pixallData, customCmp, _data$ownerId2, ownerId, inventoryId, inventoryWithOwner, cmp, isCarousel, restPixallData, parent;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref4$data = _ref4.data, data = _ref4$data === void 0 ? {} : _ref4$data, state = _ref4.state, dataLayer = _ref4.dataLayer;
          par = data.par, _data$pixallData6 = data.pixallData, pixallData = _data$pixallData6 === void 0 ? {} : _data$pixallData6, customCmp = data.cmp, _data$ownerId2 = data.ownerId, ownerId = _data$ownerId2 === void 0 ? '' : _data$ownerId2, inventoryId = data.inventoryId;
          inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
          cmp = customCmp || 'accl_btn';
          isCarousel = pixallData.isCarousel, restPixallData = _objectWithoutPropertiesLoose(pixallData, _excluded4);
          parent = par ? "_" + par : '';
          Pixall.sendClickEvent(_extends({
            label: "Click Accelerate Button - " + cmp + parent,
            eventSource: isCarousel ? 'vehicle-carousel' : 'dealership',
            // feature: 'Drive the 9',
            inventory: inventoryWithOwner,
            listingCode: ownerId,
            searchFacetZipCode: inventoryWithOwner.owner.zip,
            par: par
          }, restPixallData), dataLayer, option);

          // return data for custom event
          return _context3.abrupt("return", {
            cmp: cmp,
            par: par
          });
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _ownerAccelerateClick.apply(this, arguments);
}
export function ownerCall(_x5, _x6) {
  return _ownerCall.apply(this, arguments);
}
function _ownerCall() {
  _ownerCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5, option) {
    var _ref5$data, data, state, userDuck, dataLayer, _data$includePageId3, includePageId, inventoryId, par, clickType, position, placement, _data$pixallData7, pixallData, _data$selectedTab, selectedTab, query, payments, interactions, pageId, hasUpdatedNDSCalc, hasOpenedWallet, hasOpenedTradeIn, includeWalletData, goal, cmp, labelSuffix, inventoryWithOwner, eventElement, eventResult, label, zip, ownerId, vehicleData, isBuildAndPrice, eventData, googleProps, payload;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref5$data = _ref5.data, data = _ref5$data === void 0 ? {} : _ref5$data, state = _ref5.state, userDuck = _ref5.userDuck, dataLayer = _ref5.dataLayer;
          _data$includePageId3 = data.includePageId, includePageId = _data$includePageId3 === void 0 ? true : _data$includePageId3, inventoryId = data.inventoryId, par = data.par, clickType = data.clickType, position = data.position, placement = data.placement, _data$pixallData7 = data.pixallData, pixallData = _data$pixallData7 === void 0 ? {} : _data$pixallData7, _data$selectedTab = data.selectedTab, selectedTab = _data$selectedTab === void 0 ? 'service' : _data$selectedTab;
          query = state.query, payments = state.payments;
          interactions = payments.interactions;
          pageId = DataLayerTransformer.getPageId(dataLayer);
          hasUpdatedNDSCalc = interactions.hasUpdatedNDSCalc, hasOpenedWallet = interactions.hasOpenedWallet, hasOpenedTradeIn = interactions.hasOpenedTradeIn;
          includeWalletData = hasUpdatedNDSCalc || hasOpenedWallet || hasOpenedTradeIn;
          if (includeWalletData) {
            goal = 'Call with My Wallet Data';
          }
          cmp = 'call_slr';
          if (par != null && par.includes('alp')) {
            cmp = 'call_slr_a';
          }
          labelSuffix = includePageId ? " - " + pageId : '';
          inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
          eventElement = 'dealer';
          eventResult = 'lead::phone';
          label = "Click to Call - " + cmp + labelSuffix;
          _context4.t0 = pageId;
          _context4.next = _context4.t0 === 'fyc_srl' ? 18 : _context4.t0 === 'fyc_ncf' ? 18 : _context4.t0 === 'fyd_ddp' ? 20 : _context4.t0 === 'dlrinfoinvovrnew' ? 20 : 25;
          break;
        case 18:
          eventResult = "lead::phone::" + clickType;
          return _context4.abrupt("break", 26);
        case 20:
          eventResult = position ? "lead::phone_" + position : 'lead::phone_dealer';
          label = "lead_phone_" + position + " - " + pageId;
          inventoryWithOwner.owner = data.owner;
          eventElement = selectedTab;
          return _context4.abrupt("break", 26);
        case 25:
          return _context4.abrupt("break", 26);
        case 26:
          zip = userDuck ? userDuck.selectors.getLocation(state).zip : '';
          ownerId = _get(inventoryWithOwner, 'owner.id') || data.ownerId || '';
          vehicleData = googleInventoryTransformer(inventoryWithOwner, {
            target: 'vehicle',
            dataLayer: dataLayer
          }, true, includeWalletData);
          isBuildAndPrice = pageId === 'bld_and_pr';
          if (isBuildAndPrice) {
            eventResult = 'lead::phone::build-price';
          }

          /**
           * Dimension 135: clickType
           */
          // remove productConfiguration that cache by sent email before.
          eventData = {
            vehicle: _extends({}, vehicleData, {
              dealershipId: ownerId == null ? void 0 : ownerId.toString()
            })
          };
          if (pageId === 'fyc_srl') eventData.vehicle.clickType = clickType;
          googleProps = {
            eventElement: eventElement,
            eventAction: 'submit',
            eventResult: eventResult,
            eventData: eventData
          };
          if (placement === 'myWallet') {
            googleProps = {
              eventElement: 'dealer',
              eventAction: 'click',
              eventResult: 'lead::phone::my-wallet-deals',
              eventData: _extends({}, eventData, {
                vehicle: _extends({}, eventData.vehicle, {
                  productConfiguration: 'my-wallet'
                })
              })
            };
          }
          Pixall.sendClickEvent(_extends({
            pixallData: _extends({}, pixallData, {
              clickTypeToListingType: pageId === 'fyc_vdp'
            }),
            label: label,
            leadType: 'call',
            eventType: 'click',
            eventSource: 'lead',
            feature: 'Drive the 5',
            goal: goal,
            inventory: inventoryWithOwner,
            listingCode: ownerId,
            par: par,
            searchFacetZipCode: zip,
            zipCode: query == null ? void 0 : query.zip
          }, isBuildAndPrice && {
            pageType: 'buildprice',
            vehicleType: 'NEW'
          }), dataLayer, option);
          payload = _extends({
            cmp: cmp,
            co_txt_url: 'Call Dealer',
            par: par
          }, isBuildAndPrice && {
            pageType: 'buildprice'
          });
          Google.sendClickEvent(_extends({}, googleProps), option);

          // return data for custom event
          return _context4.abrupt("return", payload);
        case 39:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _ownerCall.apply(this, arguments);
}
function getTextLink(labelKey) {
  switch (labelKey) {
    case 'virtualTour':
      return 'text-link::set-up-a-time';
    case 'testDrive':
      return 'text-link::request-a-test-drive';
    case 'vehicleDelivery':
      return 'text-link::contact-dealer-for-details';
    default:
      return '';
  }
}
export var emailCTAMap = {
  alpha: {
    cmp: 'eml_slr_a'
  },
  availableOffers: {
    // VDP available offers fair market range
    eventElement: 'partner',
    eventResult: 'cta::contact-dealer::fair-market-range'
  },
  blinker: {
    // VDP private seller
    cmp: 'msg_pvt_slr_btn'
  },
  calculator: {
    // VDP NDS
    cmp: 'snd_dlr_ofr',
    eventResult: 'cta::send-offer',
    eventElement: 'nds',
    feature: 'NDS'
  },
  compare: {
    // SRP compare modal confirm availability
    cmp: 'eml_dlr_lnk',
    eventElement: 'compare',
    eventResult: 'cta::confirm-availability',
    clickType: 'compare',
    isCompareModel: true
  },
  compareSendOffer: {
    // SRP compare modal send offer
    cmp: 'snd_offer',
    feature: 'Compare',
    coTxtUrl: 'send offer',
    eventElement: 'compare',
    eventResult: 'cta::send-offer',
    isCompareModel: true
  },
  confirmAvailability: {
    // default
    cmp: 'eml_dlr_lnk',
    eventResult: 'text-link::confirm-availability'
  },
  creditStatus: {
    // VDP NDS You have already applied for credit. Contact Dealer
    cmp: 'nds_con_dlr_crd_app',
    coTxtUrl: 'Contact Dealer Credit Application Applied',
    eventResult: 'text-link::caca-saca::contact-dealer',
    eventElement: 'nds',
    pixallLabel: 'con_dlr_crd_appld'
  },
  longHaulDeliveryLongForm: {
    cmp: 'con_dlr_arv_shp',
    eventElement: 'dhs'
  },
  longHaulDeliveryShortForm: {
    cmp: 'ask_dlr',
    eventElement: 'dhs'
  },
  privateSellerListingCompare: {
    // Compare modal confirm availability for private seller listings
    cmp: 'eml_dlr_tred',
    eventElement: 'listings',
    eventResult: 'cta::tred::confirm-availability',
    clickType: 'compare',
    isCompareModel: true
  },
  protection: {
    // VDP Optional Add-On Protections
    cmp: 'cnct_dlr',
    coTxtUrl: 'Contact Dealer',
    eventResult: 'cta::contact-dealer::additional-protections'
  },
  quote: {
    // SRP
    cmp: 'reqst_quote',
    coTxtUrl: 'Request a Quote',
    feature: 'New Car Order',
    eventResult: 'cta::request-a-quote::new-car-custom-order',
    clickType: 'newcarcustomorder',
    carType: 'n'
  },
  testDrive: {
    cmp: 'dlr_hm_sev_lnk',
    coTxtUrl: 'dhs:test drive',
    eventElement: 'dhs',
    eventResult: 'text-link::request-a-test-drive',
    isHomeService: true
  },
  vehicleDelivery: {
    cmp: 'dlr_hm_sev_lnk',
    coTxtUrl: 'dhs:deliver',
    eventElement: 'dhs',
    eventResult: 'text-link::contact-dealer-for-details',
    isHomeService: true
  },
  virtualTour: {
    cmp: 'dlr_hm_sev_lnk',
    coTxtUrl: 'dhs:video',
    eventElement: 'dhs',
    eventResult: 'text-link::set-up-a-time',
    isHomeService: true
  },
  NO_ACCIDENTS_NO_RECALL: {
    eventResult: 'cta::no-accidents-or-current-recalls::contact-dealer',
    pixallLabel: 'cnct_dlr - No Accidents or Current Recalls'
  },
  ACCIDENTS_REPORTED: {
    eventResult: 'cta::accident-detected::contact-dealer',
    pixallLabel: 'cnct_dlr - Accident Detected'
  },
  OPEN_RECALLS_REPORTED: {
    eventResult: 'cta::active-recall-present::contact-dealer',
    pixallLabel: 'cnct_dlr - Active Recall Present'
  },
  ACCIDENTS_RECALL_REPORTED: {
    eventResult: 'cta::active-recall-and-accident-detected::contact-dealer',
    pixallLabel: 'cnct_dlr - Active Recall and Accident Detected'
  }
};

/**
 * @summary Sends event when email link/button is clicked
 * @data emailOwnerData, userDuck
 */
export function ownerEmailClick(_ref6, option) {
  var _event$target, _event$target2, _state$payments, _event$target$innerTe, _event$target3;
  var event = _ref6.event,
    _ref6$data = _ref6.data,
    data = _ref6$data === void 0 ? {} : _ref6$data,
    state = _ref6.state,
    userDuck = _ref6.userDuck,
    dataLayer = _ref6.dataLayer;
  var defaultClickType = data.clickType,
    _data$context = data.context,
    context = _data$context === void 0 ? 'confirmAvailability' : _data$context,
    _data$par = data.par,
    par = _data$par === void 0 ? '' : _data$par,
    _data$includePageId = data.includePageId,
    includePageId = _data$includePageId === void 0 ? true : _data$includePageId,
    inventoryId = data.inventoryId,
    defaultOwnerId = data.ownerId;
  var inventoryWithOwner = context === 'quote' ? _get(state, "preorder." + inventoryId, {}) : getInventoryOwnerById(state, inventoryId);
  var ownerId = _get(inventoryWithOwner, 'owner.id', '') || defaultOwnerId;
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var pageName = _get(dataLayer, 'page.pageName', '');
  var inheritPageData = !['vdp'].includes(pageName);
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer: dataLayer
  }, inheritPageData);
  var searchZip = userDuck ? userDuck.selectors.getLocation(state).zip : _get(state, 'query.zip', '');
  var defaultCoTxtUrl = ((event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.innerText) || (event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.textContent) || '').trim();
  var defaultEventElement = 'dealer';
  switch (context) {
    case 'calculator':
      defaultCoTxtUrl = (state == null ? void 0 : (_state$payments = state.payments) == null ? void 0 : _state$payments.dealType) + " " + ((_event$target$innerTe = event == null ? void 0 : (_event$target3 = event.target) == null ? void 0 : _event$target3.innerText) != null ? _event$target$innerTe : 'Send Offer');
      break;
    case 'protection':
    case 'NO_ACCIDENTS_NO_RECALL':
    case 'ACCIDENTS_REPORTED':
    case 'OPEN_RECALLS_REPORTED':
    case 'ACCIDENTS_RECALL_REPORTED':
      defaultEventElement = "vdp_" + (inventoryWithOwner == null ? void 0 : inventoryWithOwner.type.toLowerCase());
      break;
    default:
  }
  var _ref7 = emailCTAMap[context] || emailCTAMap.confirmAvailability,
    _ref7$clickType = _ref7.clickType,
    clickType = _ref7$clickType === void 0 ? defaultClickType : _ref7$clickType,
    _ref7$cmp = _ref7.cmp,
    cmp = _ref7$cmp === void 0 ? 'eml_dlr_lnk' : _ref7$cmp,
    _ref7$eventElement = _ref7.eventElement,
    eventElement = _ref7$eventElement === void 0 ? defaultEventElement : _ref7$eventElement,
    _ref7$eventResult = _ref7.eventResult,
    eventResult = _ref7$eventResult === void 0 ? "text-link::" + defaultCoTxtUrl.replace(/\s+/g, '-').toLowerCase() : _ref7$eventResult,
    _ref7$feature = _ref7.feature,
    feature = _ref7$feature === void 0 ? 'Drive the 5' : _ref7$feature,
    _ref7$isHomeService = _ref7.isHomeService,
    isHomeService = _ref7$isHomeService === void 0 ? false : _ref7$isHomeService,
    _ref7$isCompareModel = _ref7.isCompareModel,
    isCompareModel = _ref7$isCompareModel === void 0 ? false : _ref7$isCompareModel,
    pixallLabel = _ref7.pixallLabel; // if context doesn't exist in the map, use default value confirmAvailability

  var labelSuffix = includePageId ? " - " + pageId : '';
  if (context === 'privateSellerListingCompare' || !isCompareModel) {
    var _inventoryWithOwner$l;
    Pixall.sendClickEvent(_extends({
      label: "" + (pixallLabel || cmp) + labelSuffix,
      eventSource: 'vehicle',
      feature: feature,
      inventory: inventoryWithOwner,
      listingCode: ownerId,
      par: par,
      searchFacetZipCode: searchZip,
      zipCode: searchZip
    }, context === 'quote' && {
      eventSource: 'dealership',
      inventory: _extends({}, inventoryWithOwner, {
        type: 'new'
      })
    }, {
      vehicleType: inventoryWithOwner == null ? void 0 : (_inventoryWithOwner$l = inventoryWithOwner.listingType) == null ? void 0 : _inventoryWithOwner$l.toUpperCase(),
      pixallData: {
        clickTypeToListingType: pageId === 'fyc_vdp'
      }
    }), dataLayer, option);
  }
  Google.sendClickEvent({
    eventElement: eventElement,
    eventResult: eventResult,
    eventData: {
      vehicle: _extends({
        clickType: clickType
      }, ['vdp'].includes(pageName) && vehicleData, ownerId && {
        dealershipId: ownerId == null ? void 0 : ownerId.toString()
      }, isHomeService && transformProductConfig({
        homeServices: _get(inventoryWithOwner, 'owner.homeServices', {}),
        nds: hasPrice(inventoryWithOwner)
      }))
    }
  }, option);

  // return data for custom event
  return {
    cmp: cmp
  };
}

/**
 * DEPRECATED - please use ownerEmailClick
 * @summary Sends event when call to action email element is clicked
 * @data emailOwnerData, userDuck
 * @deprecated
 */
export function ownerEmailCTAClick(_ref8, option) {
  var event = _ref8.event,
    _ref8$data = _ref8.data,
    data = _ref8$data === void 0 ? {} : _ref8$data,
    state = _ref8.state,
    userDuck = _ref8.userDuck,
    dataLayer = _ref8.dataLayer;
  // !!! DEPRECATED - PLEASE USE OWNEREMAILCLICK !!!
  var clickType = data.clickType,
    _data$par2 = data.par,
    par = _data$par2 === void 0 ? '' : _data$par2,
    inventoryId = data.inventoryId,
    ownerId = data.ownerId,
    labelKey = data.labelKey,
    disableFeature = data.disableFeature,
    _data$pixallData = data.pixallData,
    pixallData = _data$pixallData === void 0 ? {} : _data$pixallData;
  var isQuote = labelKey === 'quote';
  var inventoryWithOwner = isQuote ? _get(state, "preorder." + inventoryId, {}) : getInventoryOwnerById(state, inventoryId);
  var id = _get(inventoryWithOwner, 'owner.id', '') || ownerId;
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var pageName = _get(dataLayer, 'page.pageName', '');
  var isBlinkerPrivateSellerListing = _get(inventoryWithOwner, 'owner.blinkerChatName');
  var isCompare = labelKey === 'compare' || par === 'comp_lstg' && labelKey === 'confirmAvailability';
  var isHomeServices = labelKey === 'virtualTour' || labelKey === 'testDrive' || labelKey === 'vehicleDelivery';
  var isNDSCalc = labelKey === 'calculator';
  var isConfirmAvailabilityCTA = labelKey === 'confirmAvailabilityCTA';
  var isAdditionalProtection = labelKey === 'additionalProtections';
  var isBuildAndPrice = labelKey === 'buildAndPrice';
  var isLongHaulDelivery = labelKey === 'longHaulDeliveryLongForm' || labelKey === 'longHaulDeliveryShortForm';
  var isCreditStatus = labelKey === 'creditStatus';
  var inheritPageData = !['vdp'].includes(pageName);
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer: dataLayer
  }, inheritPageData);
  var cmp = 'eml_dlr_lnk';
  var eventResult = 'text-link::confirm-availability';
  var eventData = clickType ? {
    vehicle: {
      clickType: clickType
    }
  } : {};
  var eventElement = 'dealer';
  var feature = 'Drive the 5';
  if (isBlinkerPrivateSellerListing) {
    cmp = 'msg_pvt_slr_btn'; // blinker private seller
  } else if (par === 'alp') {
    cmp = 'eml_slr_a'; // alpha
  } else if (isQuote) {
    cmp = 'reqst_quote';
    feature = 'New Car Order';
    eventResult = 'cta::request-a-quote::new-car-custom-order';
    eventData = {
      vehicle: _extends({}, ['vdp'].includes(pageName) && vehicleData, {
        clickType: 'newcarcustomorder',
        dealershipId: ownerId == null ? void 0 : ownerId.toString()
      })
    };
  } else if (isConfirmAvailabilityCTA) {
    eventResult = 'cta::confirm-availability';
    eventData = {
      vehicle: {
        dealershipId: ownerId == null ? void 0 : ownerId.toString()
      }
    };
  } else if (isCompare) {
    eventElement = 'compare';
    if (labelKey === 'confirmAvailability') {
      eventResult = 'cta::confirm-availability';
      eventData = {
        vehicle: {
          clickType: 'compare'
        }
      };
    } else {
      cmp = 'snd_offer'; // compare
      feature = 'Compare';
      eventResult = 'cta::send-offer';
      eventData = {
        vehicle: googleInventoryTransformer(inventoryWithOwner, {
          target: 'vehicle',
          dataLayer: dataLayer
        })
      };
    }
  } else if (isNDSCalc) {
    cmp = 'snd_dlr_ofr'; // nds
    eventResult = 'cta::send-offer';
    eventElement = 'nds';
    feature = 'NDS';
  } else if (isHomeServices) {
    cmp = 'dlr_hm_sev_lnk'; // dhs
    eventResult = getTextLink(labelKey);
    eventData = {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }), transformProductConfig({
        homeServices: _get(inventoryWithOwner, 'owner.homeServices', {}),
        nds: hasPrice(inventoryWithOwner)
      }))
    };
    eventElement = 'dhs';
  } else if (pageName === 'ddp') {
    eventResult = 'icon::email'; // DE190193 GA360 - DDP Email Icon Click (EVENT ID 14)  has incorrect eventResult
    eventData = {
      dealershipId: ownerId
    }; // DE191158 GA360 - DDP Email Icon Click (EVENT ID 14)  has incorrect eventData
  } else if (isAdditionalProtection) {
    cmp = 'cnct_dlr';
    eventElement = "vdp_" + (inventoryWithOwner == null ? void 0 : inventoryWithOwner.type.toLowerCase());
    eventResult = 'cta::contact-dealer::additional-protections';
    eventData = {
      vehicle: _extends({}, vehicleData)
    };
  } else if (isBuildAndPrice) {
    cmp = 'bld_pr';
    feature = 'New Car Order';
    eventElement = 'build-price';
    eventResult = 'cta::open::build-price';
    eventData = {
      vehicle: {
        clickType: 'newcarcustomorder'
      }
    };
  } else if (isLongHaulDelivery) {
    var _event$target4, _event$target5;
    var textContent = ((event == null ? void 0 : (_event$target4 = event.target) == null ? void 0 : _event$target4.innerText) || (event == null ? void 0 : (_event$target5 = event.target) == null ? void 0 : _event$target5.textContent) || '').trim();
    cmp = labelKey === 'longHaulDeliveryLongForm' ? 'con_dlr_arv_shp' : 'ask_dlr';
    eventElement = 'dhs';
    eventResult = "text-link::" + textContent.replace(/\s+/g, '-').toLowerCase();
    eventData = {
      vehicle: _extends({}, vehicleData)
    };
  } else if (isCreditStatus) {
    eventData = {
      vehicle: _extends({}, vehicleData)
    };
    cmp = 'nds_con_dlr_crd_app';
    eventResult = 'text-link::caca-saca::contact-dealer';
    eventElement = 'nds';
  }
  if (disableFeature) {
    feature = undefined;
  }
  var searchZip = userDuck ? userDuck.selectors.getLocation(state).zip : _get(state, 'query.zip', '');
  var pixallLabelCmp = cmp;
  if (isCreditStatus) {
    pixallLabelCmp = 'con_dlr_crd_appld';
  }
  if (!isCompare) {
    Pixall.sendClickEvent(_extends({
      label: pixallLabelCmp + " - " + pageId,
      eventSource: 'vehicle',
      feature: feature,
      inventory: inventoryWithOwner,
      listingCode: id,
      par: par,
      searchFacetZipCode: searchZip,
      zipCode: searchZip
    }, (isQuote || isBuildAndPrice) && {
      eventSource: 'dealership',
      inventory: _extends({}, inventoryWithOwner, {
        type: 'new'
      })
    }, {
      pixallData: _extends({}, pixallData, {
        clickTypeToListingType: pageId === 'fyc_vdp'
      })
    }), dataLayer, option);
  }
  Google.sendClickEvent({
    eventElement: eventElement,
    eventResult: eventResult,
    eventData: eventData
  }, option);

  // return data for custom event
  return {
    cmp: cmp
  };
}

/**
 * @summary Sends event after email form is submitted
 * @data emailOwnerData, userDuck
 */
export function ownerEmailSent(_ref9, option) {
  var event = _ref9.event,
    _ref9$data = _ref9.data,
    data = _ref9$data === void 0 ? {} : _ref9$data,
    state = _ref9.state,
    dataLayer = _ref9.dataLayer,
    userDuck = _ref9.userDuck;
  var ownerId = data.ownerId,
    _data$par3 = data.par,
    par = _data$par3 === void 0 ? '' : _data$par3,
    _data$cmp = data.cmp,
    cmp = _data$cmp === void 0 ? 'snd_eml' : _data$cmp,
    consumerMetadata = data.consumerMetadata,
    _data$includePageId2 = data.includePageId,
    includePageId = _data$includePageId2 === void 0 ? true : _data$includePageId2,
    inventoryId = data.inventoryId,
    testDrive = data.testDrive,
    vehicleDelivery = data.vehicleDelivery,
    virtualTour = data.virtualTour,
    includeWalletData = data.includeWalletData,
    vdpType = data.vdpType,
    formEventId = data.formEventId,
    preorderInfo = data.preorderInfo,
    serviceInquiry = data.serviceInquiry,
    context = data.context,
    subject = data.subject,
    _data$inquiryLabel = data.inquiryLabel,
    inquiryLabel = _data$inquiryLabel === void 0 ? '' : _data$inquiryLabel,
    _data$isChipEnabled = data.isChipEnabled,
    isChipEnabled = _data$isChipEnabled === void 0 ? false : _data$isChipEnabled,
    _data$pixallData2 = data.pixallData,
    pixallData = _data$pixallData2 === void 0 ? {} : _data$pixallData2;
  var isQuote = context === 'quote';
  var inventoryWithOwner = isQuote ? _get(state, "preorder." + inventoryId, {}) : getInventoryOwnerById(state, inventoryId);
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var pageName = _get(dataLayer, 'page.pageName', '');
  var zip = userDuck ? userDuck.selectors.getLocation(state).zip : '';
  var partnerName = state == null ? void 0 : state.brand;
  var goal;
  var inheritPageData;
  if (includeWalletData) {
    goal = 'Sent My Wallet Offer';
  }
  var eventResult;
  var listingCategory;
  var labelSuffix = includePageId ? " - " + pageId : '';
  var label = "Email Dealer - " + cmp + labelSuffix;
  var eventAction = 'submit';
  var feature = 'Drive the 5';
  var isCompare = vdpType === 'Compare';
  var isBuildAndPrice = context === 'buildAndPrice';
  var isLongHaulDelivery = context == null ? void 0 : context.includes('longHaul');
  var isNDSCalc = context === 'calculator';
  switch (pageName) {
    case 'vdp':
      eventResult = 'lead::email::inline';
      if (testDrive || vehicleDelivery || virtualTour) {
        eventResult = 'lead::email::dhs';
      }
      if (isNDSCalc) {
        eventResult = 'lead::email::nds';
        label = cmp;
        feature = vdpType;
      }
      if (preorderInfo) {
        eventResult = 'lead::email::new-car-custom-order';
        inheritPageData = false;
      }
      if (isCompare) {
        listingCategory = 'compare';
      }
      if (context === 'mediaGallery') {
        eventResult = 'lead::email::media-gallery';
      }
      if (context === 'stickyHeader') {
        eventResult = 'lead::email::sticky-header';
      }
      if (context === 'ownerDetails') {
        eventResult = 'lead::email::dealer-card';
      }
      if (context === 'compare') {
        eventResult = 'lead::email::compare';
      }
      if (context === 'wallet') {
        eventResult = 'lead::email::my-wallet-deals';
        goal = 'Sent My Wallet Credit App';
      }
      break;
    case 'srp':
      if (preorderInfo) {
        listingCategory = 'new-car-custom-order';
      } else {
        listingCategory = getListingCategory(par);
      }
      eventResult = "lead::email::" + listingCategory;
      break;
    case 'ddp':
      eventAction = 'click';
      eventResult = "lead::" + sanitizeValue(subject);
      break;
    case 'bap':
      eventResult = 'lead::email::build-price';
      break;
    default:
      eventResult = 'lead::email';
  }
  var inquirySelection = inquiryLabel.trim().replace(/\b's\b/g, '');
  var payload = {
    linkName: isCompare || isLongHaulDelivery ? 'Link Track' : 'Email DT5',
    leadType: 'email'
  };
  if (serviceInquiry === 'scheduleTestDrive' && !isChipEnabled) {
    if (partnerName === 'kbb') {
      payload.linkName = 'Request Appointment';
    } else {
      delete payload.linkName;
      payload.page = 'fyc_srl';
      payload.pageType = 'vlp';
    }
    label = label + " - Request_appt";
  }
  if (isChipEnabled) {
    payload.productType = inquirySelection;
    label = label + " - " + inquirySelection;
  }
  var _transformProductConf = transformProductConfig({
      homeServices: {
        testDrive: testDrive,
        vehicleDelivery: vehicleDelivery,
        virtualTour: virtualTour,
        serviceInquiry: serviceInquiry
      },
      wallet: includeWalletData || context === 'wallet',
      nds: isNDSCalc
    }),
    productConfiguration = _transformProductConf.productConfiguration;
  if (isCompare) {
    label = "Email Dealer - snd_eml - " + pageId + " - compare";
  }
  Pixall.sendClickEvent(_extends({
    pixallData: _extends({}, pixallData, {
      clickTypeToListingType: pageId === 'fyc_vdp'
    }),
    consumerMetadata: consumerMetadata,
    label: label,
    leadType: 'form',
    leadContext: 'email',
    eventType: 'submit',
    eventSource: 'lead',
    feature: feature,
    goal: goal,
    inventory: inventoryWithOwner,
    listingCode: ownerId,
    par: par,
    searchFacetZipCode: zip,
    zipCode: zip,
    formEventId: formEventId
  }, isBuildAndPrice && {
    pageType: 'buildprice'
  }, isCompare && pageName === 'srp' && {
    listingType: 'compare'
  }), dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventAction: eventAction,
    eventResult: eventResult,
    eventData: {
      vehicle: pageName === 'ddp' ? {
        dealershipId: ownerId == null ? void 0 : ownerId.toString(),
        productConfiguration: productConfiguration
      } : _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }, inheritPageData), {
        productConfiguration: productConfiguration
      }, listingCategory && {
        clickType: listingCategory
      })
    }
  }, option);

  // return data for custom event
  return {
    cmp: cmp
  };
}

/**
 * @summary Sends event when visit website button is clicked
 * @data ownerId
 */
export function ownerWebsite(_ref10, option) {
  var _dataLayer$page;
  var _ref10$data = _ref10.data,
    data = _ref10$data === void 0 ? {} : _ref10$data,
    state = _ref10.state,
    dataLayer = _ref10.dataLayer,
    rest = _objectWithoutPropertiesLoose(_ref10, _excluded2);
  var pageName = _get(dataLayer, 'page.pageName', '');
  var ownerId = data.ownerId,
    par = data.par,
    inventoryId = data.inventoryId,
    disablePixall = data.disablePixall;
  var _get2 = _get(state, "owners." + ownerId, {}),
    id = _get2.id;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var detailPageName = (_dataLayer$page = dataLayer.page) == null ? void 0 : _dataLayer$page.detailPageName; // GA detailPageName
  var inheritPageData = !['vdp'].includes(detailPageName);
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer: dataLayer
  }, inheritPageData);
  var isEsntial = !!_get(inventoryWithOwner, 'esntial', false);
  var isAccelerate = _get(inventoryWithOwner, 'paymentServices.digitalRetailingType', '') === 'accelerate';
  var pageNameList = ['vdp', 'ddp', 'fyc', 'fyd'];
  var clickType = _get(state, 'query.clickType', par != null && par.includes('alp') ? 'alpha' : undefined);
  var eventResult = pageNameList.includes(pageName) ? 'sitelink' : "sitelink::" + clickType;
  var eventElement = pageNameTransformer(pageName) || 'search-car';
  var pixallData = {
    listingCode: id
  };
  if (clickType === undefined) {
    clickType = data == null ? void 0 : data.clickType;
  }
  if (clickType === 'recommendations') {
    pixallData.clickType = clickType;
  }
  if (pageName === 'fyd_srl') {
    pixallData.listingType = clickType;
    eventResult = "sitelink::" + (pixallData == null ? void 0 : pixallData.listingType);
    eventElement = 'dealer';
  }

  // return data for custom event
  return ownerWebsiteClickHelper(_extends({
    data: _extends({}, data, {
      cmp: 'vw_wb_btn'
    }),
    pixallData: pixallData,
    googleData: {
      eventElement: eventElement,
      eventResult: eventResult,
      eventData: {
        vehicle: pageName === 'ddp' ? {
          dealershipId: ownerId == null ? void 0 : ownerId.toString()
        } : _extends({}, vehicleData, {
          clickType: clickType,
          dealershipId: ownerId == null ? void 0 : ownerId.toString()
        })
      }
    },
    state: state,
    isEsntial: isEsntial,
    isAccelerate: isAccelerate,
    disablePixall: disablePixall,
    dataLayer: dataLayer
  }, rest), option);
}

/**
 * @summary Sends event on phone number reveal
 * @data ownerId, inventoryId
 */
export function ownerPhoneNumber(_ref11, option) {
  var event = _ref11.event,
    data = _ref11.data,
    state = _ref11.state,
    dataLayer = _ref11.dataLayer;
  var ownerId = data.ownerId,
    inventoryId = data.inventoryId,
    _data$par4 = data.par,
    par = _data$par4 === void 0 ? '' : _data$par4,
    customCmp = data.cmp,
    _data$clickType = data.clickType,
    clickType = _data$clickType === void 0 ? '' : _data$clickType,
    paginatedListingIndex = data.paginatedListingIndex;
  var cmp = customCmp || 'gp';
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var owner = inventoryWithOwner.owner || _get(state, "owners." + ownerId) || {};
  var pageName = _get(state, 'currentPageName', '');
  var eventText = _get(event, 'target.innerText', '');
  var linkCopy = _kebabCase(eventText);
  var searchZip = _get(state, 'query.zip', '');
  var eventData;
  switch (pageName) {
    case 'srp':
      eventData = {
        vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
          target: 'vehicle',
          dataLayer: dataLayer
        }), {
          clickType: clickType,
          listingPosition: paginatedListingIndex
        })
      };
      break;
    case 'dealerdetails':
      eventData = {
        vehicle: {
          dealershipId: ownerId,
          listingPosition: paginatedListingIndex
        }
      };
      break;
    case 'vdp':
      eventData = {
        vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
          target: 'vehicle',
          dataLayer: dataLayer
        }))
      };
      break;
    default:
      eventData = {};
      break;
  }
  Pixall.sendClickEvent({
    label: "Click to call - " + cmp + " - " + par,
    eventSource: 'dealership',
    feature: 'Drive the 5',
    inventory: inventoryWithOwner,
    listingCode: ownerId,
    par: par,
    searchFacetZipCode: owner.zip,
    zipCode: searchZip,
    pixallData: {
      clickTypeToListingType: pageId === 'fyc_vdp'
    }
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventResult: "text-link::" + linkCopy,
    eventData: eventData
  }, option);
  // return data for custom event
  return {
    cmp: cmp,
    par: par
  };
}
export function ownerPhoneNumberImpressions(metadata, option) {
  var _kebabCase2;
  var data = metadata.data,
    state = metadata.state,
    dataLayer = metadata.dataLayer;
  var inventoryId = data.inventoryId,
    linkText = data.linkText;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  // replace whitespace with dash character,then remove anything that is not a word or dash character, and turn string to lowercase
  var linkCopy = (_kebabCase2 = _kebabCase(linkText)) != null ? _kebabCase2 : 'get-this-sellers-phone-number';
  Google.sendImpressions(metadata, {
    eventElement: 'dealer',
    eventResult: "text-link::" + linkCopy,
    eventData: {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }))
    }
  }, option);
  return {};
}

/**
 * @summary Sends event on get direction link
 * @data ownerId
 */
export function ownerLocation(_x7, _x8) {
  return _ownerLocation.apply(this, arguments);
}

/**
 * @summary Sends event on Text Owner
 * @data ownerId
 */
function _ownerLocation() {
  _ownerLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref12, option) {
    var _ref12$data, data, state, userDuck, dataLayer, customCmp, ownerId, _data$par7, par, inventoryId, placement, _data$pixallData8, pixallData, owner, searchZip, id, inventoryWithOwner, vehicleData, cmp, pageId, clickType, pageName, isBuildAndPrice, label, eventResult;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _ref12$data = _ref12.data, data = _ref12$data === void 0 ? {} : _ref12$data, state = _ref12.state, userDuck = _ref12.userDuck, dataLayer = _ref12.dataLayer;
          customCmp = data.cmp, ownerId = data.ownerId, _data$par7 = data.par, par = _data$par7 === void 0 ? '' : _data$par7, inventoryId = data.inventoryId, placement = data.placement, _data$pixallData8 = data.pixallData, pixallData = _data$pixallData8 === void 0 ? {} : _data$pixallData8;
          owner = _get(state, "owners." + ownerId, {});
          searchZip = userDuck ? userDuck.selectors.getLocation(state).zip : _get(state, 'query.zip', '');
          id = owner.id;
          inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
          vehicleData = googleInventoryTransformer(inventoryWithOwner, {
            target: 'vehicle',
            dataLayer: dataLayer
          });
          cmp = customCmp || 'cs_view_map';
          pageId = DataLayerTransformer.getPageId(dataLayer);
          clickType = _get(state, 'query.clickType', getListingCategory(par));
          pageName = _get(dataLayer, 'page.pageName', '');
          isBuildAndPrice = pageName === 'bap';
          label = "Maps - " + cmp + " - " + pageId;
          if (pageName === 'vdp' && placement === 'snapshot') {
            label = cmp + "-" + pageId;
          }
          Pixall.sendClickEvent(_extends({
            pixallData: _extends({}, pixallData, {
              clickTypeToListingType: pageId === 'fyc_vdp'
            }),
            label: label,
            eventSource: 'directions',
            feature: 'Drive the 9',
            listingCode: id,
            inventory: inventoryWithOwner,
            par: par,
            searchFacetZipCode: searchZip,
            zipCode: searchZip
          }, isBuildAndPrice && {
            pageType: 'buildprice'
          }), dataLayer, option);
          _context5.t0 = pageName;
          _context5.next = _context5.t0 === 'srp' ? 18 : _context5.t0 === 'bap' ? 20 : 22;
          break;
        case 18:
          eventResult = "directions::" + clickType;
          return _context5.abrupt("break", 23);
        case 20:
          eventResult = 'directions::build-price';
          return _context5.abrupt("break", 23);
        case 22:
          eventResult = 'directions';
        case 23:
          Google.sendClickEvent({
            eventElement: 'dealer',
            eventAction: 'click',
            eventResult: eventResult,
            eventData: {
              vehicle: pageName === 'ddp' ? {
                dealershipId: ownerId == null ? void 0 : ownerId.toString()
              } : _extends({}, vehicleData, {
                clickType: clickType
              })
            }
          }, option);

          // return data for custom event
          return _context5.abrupt("return", {
            cmp: cmp
          });
        case 25:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _ownerLocation.apply(this, arguments);
}
export function ownerText(_ref13, option) {
  var data = _ref13.data,
    state = _ref13.state,
    dataLayer = _ref13.dataLayer;
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var ownerId = data.ownerId,
    _data$par5 = data.par,
    par = _data$par5 === void 0 ? '' : _data$par5,
    inventoryId = data.inventoryId,
    placement = data.placement,
    _data$pixallData3 = data.pixallData,
    pixallData = _data$pixallData3 === void 0 ? {} : _data$pixallData3;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var _get3 = _get(state, "owners." + ownerId, {}),
    id = _get3.id,
    location = _get3.location;
  var payments = state.payments;
  var interactions = payments.interactions;
  var ownerZip = _get(location, 'address.zip', '');
  var searchZip = _get(state, 'query.zip', '');
  var pageName = _get(dataLayer, 'page.pageName', '');
  var hasUpdatedNDSCalc = interactions.hasUpdatedNDSCalc,
    hasOpenedWallet = interactions.hasOpenedWallet,
    hasOpenedTradeIn = interactions.hasOpenedTradeIn;
  var includeWalletData = hasUpdatedNDSCalc || hasOpenedWallet || hasOpenedTradeIn;
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer: dataLayer
  }, true, includeWalletData);
  var goal;
  if (includeWalletData) {
    goal = 'Text with My Wallet Data';
  }
  var cmp = 'msg_slr';
  if (par != null && par.includes('alp')) {
    cmp = 'msg_slr_a';
  }
  var label = "Chat Dealer - " + cmp + " - " + pageId;
  if (pageName === 'vdp' && placement === 'snapshot') {
    label = cmp;
  }
  var googleProps = {
    eventElement: 'dealer',
    eventAction: 'submit',
    eventResult: 'lead::text',
    eventData: {
      vehicle: _extends({}, vehicleData)
    }
  };
  if (placement === 'myWallet') {
    googleProps = {
      eventElement: 'dealer',
      eventAction: 'click',
      eventResult: 'lead::text::my-wallet-deals',
      eventData: {
        vehicle: _extends({}, vehicleData, {
          productConfiguration: 'my-wallet'
        })
      }
    };
  }
  Pixall.sendClickEvent({
    pixallData: _extends({}, pixallData, {
      clickTypeToListingType: pageId === 'fyc_vdp'
    }),
    label: label,
    eventSource: 'lead',
    feature: 'Drive the 5',
    goal: goal,
    inventory: inventoryWithOwner,
    leadType: 'text',
    listingCode: id,
    par: par,
    searchFacetZipCode: ownerZip,
    zipCode: searchZip
  }, dataLayer, option);
  Google.sendClickEvent(_extends({}, googleProps), option);

  // return data for custom event
  return {
    cmp: cmp
  };
}

/**
 * @summary Sends event on Chat Dealer button is clicked and Chat Box (Third Party)
 * @data ownerId
 */
export function ownerChat(_ref14, option) {
  var _inventoryWithOwner$o, _inventoryWithOwner$o2, _inventoryWithOwner$o3, _inventoryWithOwner$o4;
  var _ref14$data = _ref14.data,
    data = _ref14$data === void 0 ? {} : _ref14$data,
    state = _ref14.state,
    dataLayer = _ref14.dataLayer;
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var pageName = _get(dataLayer, 'page.pageName', '');
  var pageType = _get(dataLayer, 'page.pageType', '');
  var inventoryId = data.inventoryId,
    ownerId = data.ownerId,
    _data$par6 = data.par,
    customPar = _data$par6 === void 0 ? '' : _data$par6,
    customCmp = data.cmp,
    placement = data.placement,
    _data$pixallData4 = data.pixallData,
    pixallData = _data$pixallData4 === void 0 ? {} : _data$pixallData4,
    assistChannel = data.assistChannel,
    assistProduct = data.assistProduct,
    assistSubchannel = data.assistSubchannel;
  var _get4 = _get(state, "owners." + ownerId, {}),
    location = _get4.location,
    _get4$id = _get4.id,
    id = _get4$id === void 0 ? '' : _get4$id;
  var payments = state.payments;
  var interactions = payments.interactions;
  var ownerZip = _get(location, 'address.zip', '');
  var searchZip = _get(state, 'query.zip', '');
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var hasUpdatedNDSCalc = interactions.hasUpdatedNDSCalc,
    hasOpenedWallet = interactions.hasOpenedWallet,
    hasOpenedTradeIn = interactions.hasOpenedTradeIn;
  var includeWalletData = hasUpdatedNDSCalc || hasOpenedWallet || hasOpenedTradeIn;
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer: dataLayer
  }, true, includeWalletData);
  var productConfiguration = vehicleData.productConfiguration,
    dealershipId = vehicleData.dealershipId;
  var goal;
  if (includeWalletData) {
    goal = 'Chat with My Wallet Data';
  }
  var cmp = customCmp || 'cs_chat';
  var par = customPar || 'v_lstg';
  var label = "Chat " + (inventoryWithOwner != null && (_inventoryWithOwner$o = inventoryWithOwner.owner) != null && _inventoryWithOwner$o.privateSeller ? 'Private Seller' : 'Dealer') + " - " + cmp + " - " + pageId;
  if (pageName === 'vdp' && placement === 'snapshot') {
    label = cmp;
  }
  Pixall.sendClickEvent({
    pixallData: _extends({}, pixallData, {
      clickTypeToListingType: pageId === 'fyc_vdp'
    }),
    inventory: inventoryWithOwner,
    label: label,
    eventSource: inventoryWithOwner != null && (_inventoryWithOwner$o2 = inventoryWithOwner.owner) != null && _inventoryWithOwner$o2.privateSeller ? 'vehicle' : 'lead',
    feature: pageName !== 'ddp' ? 'Drive the 5' : undefined,
    goal: goal,
    leadType: inventoryWithOwner != null && (_inventoryWithOwner$o3 = inventoryWithOwner.owner) != null && _inventoryWithOwner$o3.privateSeller ? undefined : 'chat',
    listingCode: id,
    par: par,
    searchFacetZipCode: pageName !== 'ddp' ? ownerZip : undefined,
    zipCode: searchZip,
    hasListingType: pageName !== 'ddp',
    pageType: pageType,
    assistChannel: assistChannel,
    assistProduct: assistProduct,
    assistSubchannel: assistSubchannel
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: inventoryWithOwner != null && (_inventoryWithOwner$o4 = inventoryWithOwner.owner) != null && _inventoryWithOwner$o4.privateSeller ? 'private-seller' : 'dealer',
    eventAction: 'submit',
    eventResult: 'lead::chat',
    eventData: {
      vehicle: pageName === 'ddp' ? {
        productConfiguration: productConfiguration,
        dealershipId: dealershipId
      } : vehicleData
    }
  }, option);
  // return data for custom event
  return {
    cmp: cmp
  };
}

/**
 * @deprecated
 */
export function ownerViewOfferInventory() {
  return {};
}

/**
 * @summary Sends event on View Dealer Inventory link in Alpha carousel
 * @data inventoryId, ownerId, co_txt_url * need owner id in case inventory is not available
 */
export function ownerViewInventory(_ref15, option) {
  var _ref15$data = _ref15.data,
    data = _ref15$data === void 0 ? {} : _ref15$data,
    userDuck = _ref15.userDuck,
    state = _ref15.state,
    dataLayer = _ref15.dataLayer;
  var inventoryId = data.inventoryId,
    ownerId = data.ownerId;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var searchZip = userDuck ? userDuck.selectors.getLocation(state).zip : _get(state, 'query.zip', '');
  var cmp = 'view_inv';
  var par = 'alp';
  Pixall.sendClickEvent({
    label: cmp,
    eventSource: 'vehicle',
    listingCode: ownerId,
    par: par,
    inventory: inventoryWithOwner,
    searchFacetZipCode: searchZip,
    zipCode: searchZip
  }, dataLayer, option);

  // return data for custom event
  return {
    cmp: cmp,
    par: par
  };
}

/**
 * @summary Sends event on Show Hide Dealer Inventory Carousel
 * @cmp hide_v
 * @data inventoryId, co_txt_url
 * @events event1
 */
export function ownerShowHideInventory(_ref16, option) {
  var _ref16$data = _ref16.data,
    data = _ref16$data === void 0 ? {} : _ref16$data,
    state = _ref16.state,
    userDuck = _ref16.userDuck,
    dataLayer = _ref16.dataLayer;
  var inventoryId = data.inventoryId;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var zip = userDuck ? userDuck.selectors.getLocation(state).zip : '';
  var cmp = 'hide_v';
  var ownerId = _get(inventoryWithOwner, 'owner.id', '');
  var par = 'alp';
  Pixall.sendClickEvent({
    label: cmp,
    eventSource: 'vehicle',
    listingCode: ownerId,
    par: par,
    inventory: inventoryWithOwner,
    searchFacetZipCode: zip,
    zipCode: zip
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventResult: 'text-link::view-vehicles'
  }, option);

  // return data for custom event
  return {
    cmp: cmp,
    par: par
  };
}
export function ownerServiceInquiry(_ref17, option) {
  var _ref17$data = _ref17.data,
    data = _ref17$data === void 0 ? {} : _ref17$data,
    event = _ref17.event,
    state = _ref17.state,
    dataLayer = _ref17.dataLayer;
  var _state$brand = state.brand,
    brand = _state$brand === void 0 ? '' : _state$brand;
  var inventoryId = data.inventoryId,
    _data$inquiryLabel2 = data.inquiryLabel,
    inquiryLabel = _data$inquiryLabel2 === void 0 ? '' : _data$inquiryLabel2;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var listingType = inventoryWithOwner != null && inventoryWithOwner.listingType ? inventoryWithOwner == null ? void 0 : inventoryWithOwner.listingType.toLowerCase() : ((data == null ? void 0 : data.listingType) || '').toLowerCase();
  var inquirySelection = inquiryLabel.trim().replace(/\b's\b/g, '');
  var cmp = 'intrst_selection';
  var labelType = 'cta';
  var linkCopy = _kebabCase(inquirySelection);
  var payload = {};
  payload.productType = inquirySelection;
  if (brand === 'kbb') {
    payload.co_txt_url = inquirySelection;
    payload.linkName = 'Interest Selection';
  }
  payload.cmp = cmp;
  Google.sendClickEvent({
    eventElement: "vdp_" + listingType,
    eventResult: labelType + "::" + linkCopy,
    eventNonInteractive: false,
    eventData: {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }))
    }
  }, option);
  return {
    cmp: cmp
  };
}
export function ownerNextCTAClick(_ref18, option) {
  var state = _ref18.state,
    dataLayer = _ref18.dataLayer,
    _ref18$data = _ref18.data,
    data = _ref18$data === void 0 ? {} : _ref18$data;
  var inventoryId = data.inventoryId,
    _data$inquiryLabel3 = data.inquiryLabel,
    inquiryLabel = _data$inquiryLabel3 === void 0 ? '' : _data$inquiryLabel3;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var listingType = inventoryWithOwner != null && inventoryWithOwner.listingType ? inventoryWithOwner == null ? void 0 : inventoryWithOwner.listingType.toLowerCase() : ((data == null ? void 0 : data.listingType) || '').toLowerCase();
  var inquirySelection = inquiryLabel.trim().replace(/\b's\b/g, '');
  var linkCopy = _kebabCase(inquirySelection);
  var cmp = 'intrst_next';
  Google.sendClickEvent({
    eventElement: "vdp_" + listingType,
    eventResult: "cta::next::" + linkCopy,
    eventNonInteractive: false,
    eventData: {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }))
    }
  }, option);
  return {
    cmp: cmp
  };
}

/**
 * @summary Sends ecom event for Service Appointment CTA ecom impression
 * @data listingPosition, dealershipId, dealerDistance
 * Dimension 25, 33, 34
 */
export function serviceAppointmentCTAEcomImpression(metadata, option) {
  var data = metadata.data,
    state = metadata.state,
    dataLayer = metadata.dataLayer;
  var ownerData = data.owner,
    inventoryId = data.inventoryId,
    listingPosition = data.listingPosition;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var owner = inventoryWithOwner.owner;
  if (!(owner != null && owner.id)) {
    inventoryWithOwner.owner = ownerData;
  }
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'ecommerce',
    vehicleListingPosition: listingPosition,
    dataLayer: dataLayer
  });
  Google.sendImpressions(metadata, {
    event: 'ecom_event',
    eventElement: 'dealer',
    eventAction: 'ecom-impression',
    eventResult: 'service-appointment',
    eventNonInteractive: true,
    ecommerce: {
      impressions: _extends({}, vehicleData, {
        id: 'dealer_srp',
        name: 'dealer_srp',
        category: 'ecom_dealer',
        list: 'ecom_dealer'
      })
    }
  }, option);
  return {
    ownerId: ownerData == null ? void 0 : ownerData.id,
    inventoryId: inventoryId
  };
}

/**
 * @summary Sends ecom event for Service Appointment CTA ecom click
 * @data listingPosition, dealershipId, dealerDistance
 * Dimension 25, 33, 34
 */
export function serviceAppointmentCTAEcomClick(metadata, option) {
  var data = metadata.data,
    state = metadata.state,
    dataLayer = metadata.dataLayer;
  var ownerData = data.owner,
    inventoryId = data.inventoryId,
    listingPosition = data.listingPosition;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var owner = inventoryWithOwner.owner;
  if (!owner.id) {
    inventoryWithOwner.owner = ownerData;
  }
  var vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'ecommerce',
    vehicleListingPosition: listingPosition,
    dataLayer: dataLayer
  });
  Google.sendClickEvent({
    event: 'ecom_event',
    eventElement: 'dealer',
    eventAction: 'ecom-click',
    eventResult: 'cta::service-appointment',
    eventNonInteractive: true,
    ecommerce: {
      impressions: _extends({}, vehicleData, {
        id: 'dealer_srp',
        name: 'dealer_srp',
        category: 'ecom_dealer',
        list: 'ecom_dealer'
      })
    }
  }, option);
  return {
    ownerId: ownerData == null ? void 0 : ownerData.id,
    inventoryId: inventoryId
  };
}

/**
 * @summary Sends event on service appointment cta submit analytic event
 * @data productConfiguration, dealershipId
 * Dimension 134, 193
 */
export function serviceAppointmentSubmit(_ref19, option) {
  var _owner$id;
  var data = _ref19.data,
    state = _ref19.state;
  var owner = data.owner,
    inventoryId = data.inventoryId;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var onlinePaperwork = (inventoryWithOwner == null ? void 0 : inventoryWithOwner.accelerate) && hasPrice(inventoryWithOwner);
  var _transformProductConf2 = transformProductConfig({
      homeServices: _extends({}, _get(owner, 'homeServices', {}), {
        accelerate: onlinePaperwork
      }),
      shippingLabel: owner == null ? void 0 : owner.shippingLabel,
      nds: hasPrice(inventoryWithOwner)
    }),
    productConfiguration = _transformProductConf2.productConfiguration;
  Google.sendClickEvent({
    event: 'analytics_event',
    eventElement: 'dealer',
    eventAction: 'submit',
    eventResult: 'cta::service-appointment',
    eventNonInteractive: false,
    eventData: {
      vehicle: {
        dealershipId: owner == null ? void 0 : (_owner$id = owner.id) == null ? void 0 : _owner$id.toString(),
        productConfiguration: productConfiguration
      }
    }
  }, option);
  return {
    inventoryId: inventoryId
  };
}
export function ownerChangeLocationClick(_ref20, option) {
  var state = _ref20.state,
    dataLayer = _ref20.dataLayer,
    _ref20$data = _ref20.data,
    data = _ref20$data === void 0 ? {} : _ref20$data;
  var inventoryId = data.inventoryId,
    _data$zip = data.zip,
    zip = _data$zip === void 0 ? '' : _data$zip;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var cmp = 'chg_zip';
  Google.sendClickEvent({
    eventElement: 'dhs',
    eventResult: "cta::change-zip::" + zip,
    eventNonInteractive: true,
    eventData: {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }))
    }
  }, option);
  return {
    cmp: cmp,
    zip: zip
  };
}
export function ownerGetQuickEstimateClick(_ref21, option) {
  var _event$target6, _event$target7, _event$target8;
  var event = _ref21.event,
    state = _ref21.state,
    dataLayer = _ref21.dataLayer,
    _ref21$data = _ref21.data,
    data = _ref21$data === void 0 ? {} : _ref21$data;
  var inventoryId = data.inventoryId;
  var eventText = ((event == null ? void 0 : (_event$target6 = event.target) == null ? void 0 : _event$target6.innerText) || (event == null ? void 0 : (_event$target7 = event.target) == null ? void 0 : _event$target7.textContent) || (event == null ? void 0 : (_event$target8 = event.target) == null ? void 0 : _event$target8.value) || '').trim();
  var linkCopy = _kebabCase(eventText);
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var cmp = 'get_q_est';
  Google.sendClickEvent({
    eventElement: 'dhs',
    eventResult: "text-link::" + linkCopy,
    eventNonInteractive: true,
    eventData: {
      vehicle: _extends({}, googleInventoryTransformer(inventoryWithOwner, {
        target: 'vehicle',
        dataLayer: dataLayer
      }))
    }
  }, option);
  return {
    cmp: cmp
  };
}
export function ownerEmailConfirmationNextStepsClick(_ref22, option) {
  var _event$target9, _event$target10;
  var event = _ref22.event;
  var ctaLabel = ((event == null ? void 0 : (_event$target9 = event.target) == null ? void 0 : _event$target9.innerText) || (event == null ? void 0 : (_event$target10 = event.target) == null ? void 0 : _event$target10.textContent) || '').trim();
  var linkCopy = _kebabCase(ctaLabel);
  Google.sendClickEvent({
    eventElement: 'partner',
    eventResult: "text-link::fake-door::" + linkCopy,
    eventNonInteractive: true
  }, option);
  return {
    linkCopy: linkCopy
  };
}
export function dealerRatingImpressions(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  var _metadata = metadata,
    _metadata$data = _metadata.data,
    data = _metadata$data === void 0 ? {} : _metadata$data;
  var id = data.id;
  Google.sendImpressions(metadata, {
    eventElement: 'dealer-rating',
    eventResult: 'rating',
    eventData: {
      svocId: id == null ? void 0 : id.toString()
    }
  }, option);
  return {};
}
export function dealerRatingClick(_ref23, option) {
  var _ref23$data = _ref23.data,
    data = _ref23$data === void 0 ? {} : _ref23$data;
  var ratingSource = data.ratingSource,
    value = data.value,
    count = data.count,
    id = data.id;
  Google.sendClickEvent({
    eventElement: 'dealer-rating',
    eventResult: "rating::" + ratingSource + "::" + value + "::" + count,
    eventData: {
      svocId: id == null ? void 0 : id.toString()
    }
  }, option);
  return {};
}

/**
 * @summary Sends event when email subcribe button is clicked
 * @data cardType
 */
export function ownerEmailSubcribeClick(_ref24, option) {
  var _ref24$data = _ref24.data,
    data = _ref24$data === void 0 ? {} : _ref24$data,
    state = _ref24.state,
    dataLayer = _ref24.dataLayer;
  var inventoryId = data.inventoryId;
  var inventory = getInventoryOwnerById(state, inventoryId);
  var listingType = _get(inventory, 'listingType', '').toLowerCase();
  var eventResult = 'cta::alert::subcribe::email';
  Google.sendClickEvent({
    eventElement: "vdp_" + listingType,
    eventResult: eventResult,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer: dataLayer
      })
    }
  }, option);

  // return data for custom event
  return {
    cmp: eventResult
  };
}

/**
 * @summary Sends event on contact us button is clicked
 * @data owner, inventoryId
 * Dimension 134, 193
 */

export function ownerContactClick(_ref25, option) {
  var _owner$id2;
  var _ref25$data = _ref25.data,
    data = _ref25$data === void 0 ? {} : _ref25$data,
    state = _ref25.state;
  var owner = data.owner,
    inventoryId = data.inventoryId,
    includeWalletData = data.includeWalletData;
  var inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  var eventResult = 'cta::email::contact-us';
  var _transformProductConf3 = transformProductConfig({
      homeServices: _get(owner, 'homeServices', {}),
      wallet: includeWalletData,
      nds: hasPrice(inventoryWithOwner)
    }),
    productConfiguration = _transformProductConf3.productConfiguration;
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventAction: 'submit',
    eventResult: eventResult,
    eventData: {
      vehicle: {
        dealershipId: owner == null ? void 0 : (_owner$id2 = owner.id) == null ? void 0 : _owner$id2.toString(),
        productConfiguration: productConfiguration
      }
    }
  }, option);
  // return data for custom event
  return {
    cmp: eventResult
  };
}
export default {
  ownerAccelerateClick: ownerAccelerateClick,
  ownerImpression: ownerImpression,
  ownerImpressions: ownerImpressions,
  ownerClick: ownerClick,
  ownerLogoClick: ownerLogoClick,
  ownerCall: ownerCall,
  ownerEmailClick: ownerEmailClick,
  ownerEmailCTAClick: ownerEmailCTAClick,
  ownerEmailSent: ownerEmailSent,
  ownerWebsite: ownerWebsite,
  ownerPhoneNumber: ownerPhoneNumber,
  ownerPhoneNumberImpressions: ownerPhoneNumberImpressions,
  ownerLocation: ownerLocation,
  ownerText: ownerText,
  ownerChat: ownerChat,
  ownerShowHideInventory: ownerShowHideInventory,
  ownerViewOfferInventory: ownerViewOfferInventory,
  ownerViewInventory: ownerViewInventory,
  ownerServiceInquiry: ownerServiceInquiry,
  ownerNextCTAClick: ownerNextCTAClick,
  serviceAppointmentSubmit: serviceAppointmentSubmit,
  serviceAppointmentCTAEcomImpression: serviceAppointmentCTAEcomImpression,
  serviceAppointmentCTAEcomClick: serviceAppointmentCTAEcomClick,
  ownerChangeLocationClick: ownerChangeLocationClick,
  ownerGetQuickEstimateClick: ownerGetQuickEstimateClick,
  ownerEmailConfirmationNextStepsClick: ownerEmailConfirmationNextStepsClick,
  ownerEmailSubcribeClick: ownerEmailSubcribeClick,
  dealerRatingClick: dealerRatingClick,
  dealerRatingImpressions: dealerRatingImpressions
};